<template>
  <a-drawer title="区域停水管控" :visible="visible" @close="handleClose" placement="left" :mask="false" :width="510">
    <a-table :data-source="tableData" :columns="columns" :pagination="false" :loading="loading"
      :row-class-name="getRowClassName" :row-key="record => record.id || record.class_no" size="small"
      :scroll="{ y: '285px' }">
      <span slot="action" slot-scope="text, record" class="action-buttons">
        <a-button v-if="record.superior" :type="isSelected(record.id) ? 'primary' : 'default'" size="small"
          @click="handleSuperiorValve(record)" :class="['superior-btn', { 'selected': isSelected(record.id) }]">
          <a-icon :type="isSelected(record.id) ? 'check' : 'arrow-up'" />
          {{ isSelected(record.id) ? '已选中' : '上级阀门' }}
        </a-button>
        <a-button :type="isDisplayed(record.id) ? 'primary' : 'default'" size="small" @click="handleDisplay(record)"
          :class="['display-btn', { 'displayed': isDisplayed(record.id) }]">
          <a-icon :type="isDisplayed(record.id) ? 'eye-invisible' : 'eye'" />
          {{ isDisplayed(record.id) ? '取消展示' : '展示' }}
        </a-button>
      </span>
    </a-table>
    <div class="footer">
      <a-row :gutter="48" type="flex">
        <a-col :md="8" :sm="10">
          <a-button block :class="['filter-btn', { 'active': activeFilters.includes('masterValve') }]"
            @click="toggleFilter('masterValve')">
            查看主控阀门
          </a-button>
        </a-col>
        <a-col :md="8" :sm="10">
          <a-button block :class="['filter-btn', { 'active': activeFilters.includes('affectedValve') }]"
            @click="toggleFilter('affectedValve')">
            查看影响阀门
          </a-button>
        </a-col>
        <a-col :md="8" :sm="10">
          <a-button block :class="['filter-btn', { 'active': activeFilters.includes('interconnectValve') }]"
            @click="toggleFilter('interconnectValve')">
            查看互通阀门
          </a-button>
        </a-col>
      </a-row>
      <a-row :gutter="48" type="flex" style="margin-top: 10px">
        <a-col :md="8" :sm="10">
          <a-button block :class="['filter-btn', { 'active': activeFilters.includes('drainValve') }]"
            @click="toggleFilter('drainValve')">
            查看排水阀
          </a-button>
        </a-col>
        <a-col :md="8" :sm="10">
          <a-button block :class="['filter-btn', { 'active': activeFilters.includes('hydrant') }]"
            @click="toggleFilter('hydrant')">
            查看消防栓
          </a-button>
        </a-col>
        <a-col :md="8" :sm="10">
          <a-button block :class="['filter-btn', { 'active': activeFilters.includes('affectedPipe') }]"
            @click="toggleFilter('affectedPipe')">
            受影响管道
          </a-button>
        </a-col>
      </a-row>
      <a-row :gutter="48" type="flex" style="margin-top: 10px">
        <a-col :md="8" :sm="10">
          <a-button block :class="['filter-btn', { 'active': activeFilters.includes('affectedMeter') }]"
            @click="toggleFilter('affectedMeter')">
            受影响水表
          </a-button>
        </a-col>
        <a-col :md="8" :sm="10">
          <a-button block class="filter-btn" @click="showAffectedUsers">
            受影响用户
          </a-button>
        </a-col>
      </a-row>

      <!-- 关联停水事件信息 -->
      <div class="water-event-info">
        <a-spin :spinning="waterEventLoading" size="small">
          <div v-if="currentLinkedWaterEvent" class="event-card">
            <div class="event-card-header">
              <a-icon type="thunderbolt" class="event-icon" />
              <span class="event-label">关联停水事件</span>
              <a-tag :color="currentLinkedWaterEvent.status === 0 ? 'red' : 'green'" class="event-status-tag">
                {{ currentLinkedWaterEvent.status === 0 ? '未处理' : '已处理' }}
              </a-tag>
            </div>
            <div class="event-card-body">
              <div class="event-field">
                <span class="field-label">事件编号：</span>
                <span class="field-value">{{ currentLinkedWaterEvent.eventNo }}</span>
              </div>
              <div class="event-field">
                <span class="field-label">事件名称：</span>
                <span class="field-value">{{ currentLinkedWaterEvent.eventName }}</span>
              </div>
              <div class="event-field" v-if="currentLinkedWaterEvent.planStartTime">
                <span class="field-label">计划停水：</span>
                <span class="field-value">{{ currentLinkedWaterEvent.planStartTime }} ~ {{ currentLinkedWaterEvent.planEntTime }}</span>
              </div>
            </div>
            <div class="event-card-footer">
              <a-button size="small" icon="eye" @click="eventDetailVisible = true" style="margin-left: auto">
                查看详情
              </a-button>
            </div>
          </div>
          <div v-else-if="!waterEventLoading" class="event-empty">
            <a-icon type="info-circle" style="margin-right: 6px; color: #faad14" />
            <span>暂无关联停水事件，新增停水事件后可发送短信和微信通知</span>
          </div>
        </a-spin>
      </div>

      <a-row :gutter="48" type="flex" style="margin-top: 10px">
        <a-col :md="24" :sm="24">
          <a-button block class="add-event-btn" @click="addWaterEventHandle" :disabled="hasPendingLinkedWaterEvent">
            <a-icon type="plus" />
            {{ hasPendingLinkedWaterEvent ? '存在未处理停水事件' : '新增停水事件' }}
          </a-button>
        </a-col>
      </a-row>

    </div>

    <!-- 停水事件详情弹窗 -->
    <a-modal title="关联停水事件详情" v-model="eventDetailVisible" width="700px" :footer="null" :bodyStyle="{ padding: '16px 24px' }">
      <a-descriptions bordered :column="2" size="small" v-if="currentLinkedWaterEvent" class="detail-descriptions">
        <a-descriptions-item label="事件编号" :span="2">
          <span style="font-weight: 500;">{{ currentLinkedWaterEvent.eventNo || '-' }}</span>
        </a-descriptions-item>
        <a-descriptions-item label="事件名称" :span="2">{{ currentLinkedWaterEvent.eventName || '-' }}</a-descriptions-item>
        <a-descriptions-item label="计划开始时间">{{ currentLinkedWaterEvent.planStartTime || '-' }}</a-descriptions-item>
        <a-descriptions-item label="计划结束时间">{{ currentLinkedWaterEvent.planEntTime || '-' }}</a-descriptions-item>
        <a-descriptions-item label="开始分类编号">{{ currentLinkedWaterEvent.startClassNo || '-' }}</a-descriptions-item>
        <a-descriptions-item label="结束分类编号">{{ currentLinkedWaterEvent.endClassNo || '-' }}</a-descriptions-item>
        <a-descriptions-item label="事件管理员">{{ currentLinkedWaterEvent.adminName || '-' }}</a-descriptions-item>
        <a-descriptions-item label="事件负责人">{{ currentLinkedWaterEvent.principalName || '-' }}</a-descriptions-item>
        <a-descriptions-item label="停水管理员">{{ currentLinkedWaterEvent.waterAdminName || '-' }}</a-descriptions-item>
        <!-- <a-descriptions-item label="停水影响区域" :span="2">{{ currentLinkedWaterEvent.eventAddress || '-' }}</a-descriptions-item> -->
        <a-descriptions-item label="状态">
          <a-tag :color="currentLinkedWaterEvent.status === 0 ? 'red' : 'green'">
            {{ currentLinkedWaterEvent.status === 0 ? '未处理' : '已处理' }}
          </a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="数据来源">{{ currentLinkedWaterEvent.source || '-' }}</a-descriptions-item>
        <a-descriptions-item label="创建时间">{{ currentLinkedWaterEvent.createTime || '-' }}</a-descriptions-item>
        <a-descriptions-item label="事件描述" :span="2">{{ currentLinkedWaterEvent.describe || '-' }}</a-descriptions-item>
        <a-descriptions-item label="附件" :span="2" v-if="currentLinkedWaterEvent.fileNames && currentLinkedWaterEvent.fileNames.length > 0">
          <div class="detail-file-list">
            <div v-for="(file, index) in currentLinkedWaterEvent.fileNames" :key="index" class="detail-file-item">
              <a-icon type="paper-clip" style="margin-right: 4px;" />
              <a @click="uploadFile(file)">{{ file.name || file.fileName || '附件' + (index + 1) }}</a>
            </div>
          </div>
        </a-descriptions-item>
      </a-descriptions>
    </a-modal>

    <!-- 新增停水事件弹窗 -->
    <a-modal title="新增停水事件" width="700px" v-model="addEventVisible" @ok="handleEventOk" @cancel="handleEventCancel" :maskClosable="false" destroyOnClose>
      <a-form-model class="log-form event-form" :model="gisWaterEvent" ref="gisWaterEvent" :rules="eventRules"
        :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="事件名称" prop="eventName">
          <a-input v-model="gisWaterEvent.eventName" placeholder="请输入事件名称" />
        </a-form-model-item>
        
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="计划开始时间" prop="startValue" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
              <a-date-picker v-model="gisWaterEvent.startValue" :disabled-date="disabledStartDate" style="width: 100%"
                @change="onChanges" format="YYYY-MM-DD HH:mm:ss" @openChange="handleStartOpenChange" placeholder="请选择开始时间" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="计划结束时间" prop="endValue" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
              <a-date-picker v-model="gisWaterEvent.endValue" :disabled-date="disabledEndDate" style="width: 100%"
                format="YYYY-MM-DD HH:mm:ss" :open="endOpen" @change="onChanget"
                @openChange="handleEndOpenChange" placeholder="请选择结束时间" />
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="事件管理员" prop="adminId" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
              <a-select show-search style="width: 100%" v-model="gisWaterEvent.adminId" placeholder="请选择事件管理员"
                option-filter-prop="children" :filter-option="filterOption">
                <a-select-option v-for="item in userlist" :key="item.id" :value="item.id">{{ item.realName }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="事件负责人" prop="principalId" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
              <a-select show-search style="width: 100%" v-model="gisWaterEvent.principalId" placeholder="请选择事件负责人"
                option-filter-prop="children" :filter-option="filterOption">
                <a-select-option v-for="item in userlist" :key="item.id" :value="item.id">{{ item.realName }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-form-model-item label="停水管理员">
          <a-input disabled v-model="gisWaterEvent.waterAdminName" placeholder="自动生成" />
        </a-form-model-item>


        <!-- <a-form-model-item label="模板选择" prop="templateId">
          <a-select v-model="gisWaterEvent.templateId" placeholder="请选择短信模板" allow-clear show-search
            option-filter-prop="children" :filter-option="filterOption">
            <a-select-option v-for="item in aliyunTemplateList" :key="item.id" :value="item.id">
              {{ item.templateName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="模板内容">
          <a-textarea :value="selectedTemplateContent" :rows="3" disabled
            placeholder="请先选择短信模板" class="template-textarea" />
        </a-form-model-item> -->

        <a-form-model-item label="事件描述" prop="describe">
          <a-textarea placeholder="请输入事件的详细描述" v-model="gisWaterEvent.describe" :rows="3" />
        </a-form-model-item>

        <a-form-model-item label="附件上传">
          <a-upload-dragger name="file" :multiple="true" :customRequest="customRequest" :showUploadList="false" class="custom-dragger">
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">点击或将文件拖拽到这里上传</p>
            <p class="ant-upload-hint">支持扩展名：.jpg .png .jpeg .pdf .doc .docx 等，最多上传5个附件</p>
          </a-upload-dragger>
          
          <div class="upload-preview-area" v-if="fileNamesimg.length > 0 || fileNamestex.length > 0">
            <div class="preview-section" v-if="fileNamesimg.length > 0">
              <div class="section-title">图片附件：</div>
              <div class="image-list">
                <div class="image-item" v-for="item in fileNamesimg" :key="item.url">
                  <img :src="item.url" @click="clicimg(item.url)" />
                  <div class="delete-mask" @click.stop="deleteFile(item.url)">
                    <a-icon type="delete" />
                  </div>
                </div>
              </div>
            </div>
            
            <div class="preview-section" v-if="fileNamestex.length > 0">
              <div class="section-title">文件附件：</div>
              <div class="file-list">
                <div class="file-item" v-for="item in fileNamestex" :key="item.url">
                  <a-icon type="paper-clip" class="file-icon" />
                  <span class="file-name" @click="uploadFile(item)" :title="item.name">{{ item.name }}</span>
                  <a-icon type="close-circle" class="delete-icon" @click="deleteFile(item.url)" />
                </div>
              </div>
            </div>
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 图片预览弹窗 -->
    <a-modal title="图片" style="top: 20px" :width="800" :footer="null" :visible="previewVisible"
      @cancel="previewVisible = false">
      <img :src="previewUrl" :alt="previewUrl" style="width: 100%; height: 100%" />
    </a-modal>
  </a-drawer>
</template>
<script>
import dayjs from 'dayjs'
import { getAliyunTemplates } from '@/api/aliyunSms'

export default {
  name: 'WaterCutOff',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    pipelineId: {
      type: String,
      default: ''
    },
    pipelineFeature: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      queryUrl: '/pipe-network/gis/pipe-networks/analysis-of-tube-burst-optimized',
      addOrUpdateUrl: '/pipe-network/gis_water_events',
      uploadUrl: 'manager/file/resources/upload',
      queryParams: {
        isPipeNetwork: false
      },
      dataSource: [],
      currentDisplayPipelineId: '', // 当前显示的管线ID
      selectedValves: [], // 已选中的阀门ID列表
      activeFilters: [], // 已激活的筛选按钮
      responseData: null, // 完整的响应数据
      displayedValveId: null, // 当前展示的阀门ID
      loading: {
        spinning: false,
        tip: '加载中...'
      }, // 加载状态
      // 关联停水事件
      linkedWaterEvent: null,
      waterEventLoading: false,
      // 新增停水事件相关
      addEventVisible: false,
      eventDetailVisible: false,
      endOpen: false,
      previewVisible: false,
      previewUrl: '',
      userlist: [],
      aliyunTemplateList: [],
      fileNamesimg: [],
      fileNamestex: [],
      gisWaterEvent: {
        lineId: '',
        eventName: '',
        startClassNo: '',
        endClassNo: '',
        endValue: '',
        startValue: '',
        describe: '',
        planEntTime: '',
        planStartTime: '',
        waterAdminName: '',
        eventAddress: '',
        fileNames: [],
        adminId: '',
        principalId: '',
        templateId: undefined
      },
      columns: [
        {
          title: '分类编码',
          dataIndex: 'class_no',
          align: 'center',
          width: '150px'
        },
        {
          title: '阀门级别',
          dataIndex: 'valveLevel',
          align: 'center',
          width: '100px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  computed: {
    selectedTemplateContent () {
      if (!this.gisWaterEvent.templateId) return ''
      const t = this.aliyunTemplateList.find(item => item.id === this.gisWaterEvent.templateId)
      if (!t || !t.templateContent) return ''
      // 替换模板变量
      let content = t.templateContent
      const { eventName, planStartTime, planEntTime } = this.gisWaterEvent
      if (eventName) {
        content = content.replace(/\$\{event_name\}/g, eventName)
      }
      if (planStartTime) {
        content = content.replace(/\$\{s_time\}/g, planStartTime)
      }
      if (planEntTime) {
        content = content.replace(/\$\{e_time\}/g, planEntTime)
      }
      return content
    },
    eventRules () {
      return {
        eventName: [{ required: true, message: '请输入事件名称', trigger: 'change' }],
        describe: [{ required: true, message: '请输入描述', trigger: 'change' }],
        startValue: [{ required: true, message: '请选择计划开始时间', trigger: 'change' }],
        endValue: [{ required: true, message: '请选择计划完成时间', trigger: 'change' }],
        principalId: [{ required: true, message: '请选择事件负责人', trigger: 'change' }],
        adminId: [{ required: true, message: '请选择事件管理员', trigger: 'change' }],
        templateId: [{ required: true, message: '请选择短信模板', trigger: 'change' }]
      }
    },
    // 合并原始数据和已选中的阀门数据
    tableData () {
      // 原始数据（valves）
      const originalData = this.dataSource || [];

      // 合并数据，去重
      const mergedMap = new Map();

      // 先添加原始数据
      originalData.forEach(item => {
        mergedMap.set(item.id, { ...item, isSelected: false });
      });

      // 更新已选中的状态，如果不存在则添加
      this.selectedValves.forEach(valve => {
        if (mergedMap.has(valve.id)) {
          // 已存在，更新状态
          mergedMap.get(valve.id).isSelected = true;
        } else {
          // 不存在，添加到表格（来自 classNos）
          mergedMap.set(valve.id, { ...valve, isSelected: true });
        }
      });

      // 排序：已选中的显示在前面
      const result = Array.from(mergedMap.values());
      console.log('合并后的数据:', result);
      return result.sort((a, b) => {
        if (a.isSelected && !b.isSelected) return -1;
        if (!a.isSelected && b.isSelected) return 1;
        return 0;
      });
    },
    currentLinkedWaterEvent () {
      if (Array.isArray(this.linkedWaterEvent)) {
        return this.linkedWaterEvent[0] || null
      }
      return this.linkedWaterEvent || null
    },
    hasPendingLinkedWaterEvent () {
      return !!(this.currentLinkedWaterEvent && this.currentLinkedWaterEvent.status === 0)
    }
  },
  watch: {
    // 监听 pipelineId 变化，自动查询数据
    pipelineId: {
      handler (newId) {
        if (newId && this.visible) {
          console.log('管线ID变化，查询停水管控数据:', newId);
          // 保存当前显示的管线ID
          this.currentDisplayPipelineId = newId;
          this.selectedValves = [];
          this.activeFilters = [];
          this.responseData = null;
          this.displayedValveId = null;
          this.loadWaterControlData();
          this.loadLinkedWaterEvent(newId);
        }
      },
      immediate: true
    }
  },
  methods: {
    handleClose () {
      // 清空数据
      this.dataSource = [];
      this.currentDisplayPipelineId = '';
      this.selectedValves = [];
      this.activeFilters = [];
      this.responseData = null;
      this.displayedValveId = null;
      this.loading.spinning = false;
      this.linkedWaterEvent = null;
      this.waterEventLoading = false;

      // 清除所有停水管控相关图层
      this.clearAllLayers();

      this.$emit('close')
    },

    // 清除所有停水管控相关图层
    clearAllLayers () {
      console.log('清除所有停水管控相关图层');
      // 触发清除所有图层的事件
      this.$emit('clear-all-layers');
    },

    // 加载停水管控数据
    async loadWaterControlData () {
      if (!this.currentDisplayPipelineId) {
        console.warn('管线ID为空，无法查询数据');
        return;
      }

      try {
        console.log('开始查询停水管控数据');
        console.log('当前管线ID:', this.currentDisplayPipelineId);
        console.log('已选中的阀门IDs:', this.selectedValves);

        // 清除之前的图层
        this.clearAllLayers();

        // 开始加载
        this.loading.spinning = true;

        const params = {
          ...this.queryParams,
          pipeLineLayerId: this.currentDisplayPipelineId // 当前管线ID
        };

        // 如果有选中的阀门，将它们的ID用逗号拼接作为 gisPipeNetworks 参数
        if (this.selectedValves.length > 0) {
          const ids = this.selectedValves.map(v => v.id);
          params.gisPipeNetworks = ids.join(',');
          console.log('gisPipeNetworks 参数:', params.gisPipeNetworks);
          console.log('选中的阀门:', this.selectedValves.map(v => v.class_no).join(', '));
        }

        const response = await this.$http.get(this.queryUrl, { params });

        if (response && response.data) {
          // 保存完整的响应数据
          this.responseData = response.data;
          console.log('完整响应数据:', this.responseData);

          this.dataSource = response.data.valves || [];
          console.log('停水管控数据查询成功:', this.dataSource);

          // 如果返回的数据中有 classNos，将它们添加到已选中列表
          if (response.data.classNos && Array.isArray(response.data.classNos)) {
            console.log('返回的已选中阀门classNos:', response.data.classNos);

            // 将 classNos 数据合并到 selectedValves（去重）
            response.data.classNos.forEach(classNo => {
              // 检查是否已经在选中列表中
              const exists = this.selectedValves.some(v => v.class_no === classNo.class_no);
              if (!exists) {
                this.selectedValves.push(classNo);
              }
            });

            console.log('更新后的已选中阀门:', this.selectedValves);
          }
        } else {
          this.dataSource = [];
          this.responseData = null;
          console.log('未查询到停水管控数据');
        }
      } catch (error) {
        console.error('查询停水管控数据失败:', error);
        this.$message?.error('查询停水管控数据失败');
        this.dataSource = [];
        this.responseData = null;
      } finally {
        // 结束加载
        this.loading.spinning = false;
      }
    },

    // 处理上级阀门按钮点击（切换选中状态）
    handleSuperiorValve (record) {
      console.log('点击阀门按钮:', record);

      if (!record.id) {
        console.warn('阀门ID为空');
        return;
      }

      // 判断是否已选中
      const index = this.selectedValves.findIndex(v => v.id === record.id);

      if (index > -1) {
        // 已选中，取消选中
        this.selectedValves.splice(index, 1);
        console.log('取消选中阀门:', record.class_no, record.id);
      } else {
        // 未选中，添加选中（保存完整数据）
        this.selectedValves.push(record);
        console.log('选中阀门:', record.class_no, record.id);
      }

      // 清空筛选按钮的激活状态（使用 splice 确保响应式）
      this.activeFilters.splice(0, this.activeFilters.length);
      console.log('清空筛选按钮状态，当前状态:', this.activeFilters);

      // 清空展示状态
      this.displayedValveId = null;

      // 清除所有图层
      this.clearAllLayers();

      // 触发更新已选中阀门图层事件
      this.$emit('update-selected-valves', this.selectedValves);

      // 强制更新视图，确保按钮状态更新
      this.$nextTick(() => {
        this.$forceUpdate();
      });

      // 重新查询停水管控数据
      this.loadWaterControlData();
    },

    // 判断是否已选中
    isSelected (id) {
      return this.selectedValves.some(v => v.id === id);
    },

    // 判断是否正在展示
    isDisplayed (id) {
      return this.displayedValveId === id;
    },

    // 获取行的 class name（为已选中的行添加特殊样式）
    getRowClassName (record) {
      return record.isSelected ? 'selected-row' : '';
    },

    // 处理展示按钮点击
    handleDisplay (record) {
      console.log('展示阀门:', record);

      if (this.displayedValveId === record.id) {
        // 如果当前阀门已经在展示，则取消展示
        console.log('取消展示阀门:', record.class_no);
        this.displayedValveId = null;
        // 触发清除高亮图层事件
        this.$emit('cancel-display-valve');
      } else {
        // 展示该阀门
        console.log('展示阀门:', record.class_no);
        this.displayedValveId = record.id;
        // 触发展示事件
        this.$emit('display-valve', record);
      }
    },

    // 切换筛选按钮状态
    toggleFilter (filterType) {
      console.log('切换筛选按钮:', filterType);

      const index = this.activeFilters.indexOf(filterType);
      if (index > -1) {
        // 已激活，取消激活
        this.activeFilters.splice(index, 1);
        console.log('取消激活筛选:', filterType);
      } else {
        // 未激活，激活
        this.activeFilters.push(filterType);
        console.log('激活筛选:', filterType);
      }

      // 触发筛选事件，由父组件处理，传递完整的响应数据
      this.$emit('filter-change', {
        filterType: filterType,
        activeFilters: this.activeFilters,
        pipelineId: this.currentDisplayPipelineId,
        selectedValves: this.selectedValves,
        responseData: this.responseData
      });
    },

    // 显示受影响用户
    showAffectedUsers () {
      console.log('点击受影响用户按钮');


      if (!this.responseData || !this.responseData.waters) {
        this.$message?.warning('暂无受影响用户数据');
        return;
      }

      // 提取所有 class_no，用逗号拼接
      const classNos = this.responseData.waters.map(item => item.class_no).join(',');

      // 触发事件，传递数据给父组件
      this.$emit('show-affected-users', {
        classNos: classNos,
        pipelineId: this.currentDisplayPipelineId,
        responseData: this.responseData,
        linkedWaterEvents: Array.isArray(this.linkedWaterEvent)
          ? this.linkedWaterEvent
          : (this.linkedWaterEvent ? [this.linkedWaterEvent] : [])
      });
    },

    jumpFather (record) {
      // this.$emit('jumpFather', record)
    },
    details (geophysicalPointNumber) {
      // this.$emit('details', geophysicalPointNumber)
    },

    // 根据管线ID查询关联停水事件
    async loadLinkedWaterEvent (lineId) {
      if (!lineId) return
      this.waterEventLoading = true
      this.linkedWaterEvent = null
      try {
        const res = await this.$http.get('/pipe-network/gis_water_events/getGisWaterEventBylineId', {
          params: { lineId }
        })
        if (res && res.code === 0) {
          if (Array.isArray(res.data)) {
            this.linkedWaterEvent = res.data
          } else if (res.data) {
            this.linkedWaterEvent = [res.data]
          } else {
            this.linkedWaterEvent = []
          }
        } else {
          this.linkedWaterEvent = []
        }
      } catch (e) {
        this.linkedWaterEvent = []
      } finally {
        this.waterEventLoading = false
      }
    },

    // 新增停水事件
    addWaterEventHandle () {
      this.gisWaterEvent.lineId = this.currentDisplayPipelineId
      this.gisWaterEvent.waterAdminName = this.$store.getters.userInfo.nickName
      // 从管线要素中自动带入起止分类编码
      if (this.pipelineFeature && this.pipelineFeature.properties) {
        const props = this.pipelineFeature.properties
        this.gisWaterEvent.startClassNo = props.start_class_no || props.startClassNo || ''
        this.gisWaterEvent.endClassNo = props.end_class_no || props.endClassNo || ''
      }
      this.getUserList()
      this.loadAliyunTemplates()
      this.addEventVisible = true
    },
    getUserList () {
      this.$http.get('/manager/users/list').then(({ data }) => {
        this.userlist = data
      })
    },
    async loadAliyunTemplates () {
      try {
        const res = await getAliyunTemplates({ ispage: 1 })
        const rows = res?.rows || []
        this.aliyunTemplateList = rows.flatMap(r => r.aliyunTemplateVos || [])
      } catch (e) {
        this.aliyunTemplateList = []
      }
    },
    filterOption (input, option) {
      const children = option && option.componentOptions && option.componentOptions.children
      if (!children || !children.length) return false
      const first = children[0]
      const text = (first && first.text != null ? first.text : '') || ''
      return String(text).toLowerCase().indexOf(String(input || '').toLowerCase()) >= 0
    },
    disabledStartDate (current) {
      return current && current < dayjs().startOf('day')
    },
    disabledEndDate (endValue) {
      const startValue = this.gisWaterEvent.startValue
      if (!endValue || !startValue) return false
      return startValue.valueOf() >= endValue.valueOf()
    },
    handleStartOpenChange (open) {
      if (!open) this.endOpen = true
    },
    handleEndOpenChange (open) {
      this.endOpen = open
    },
    onChanges (value, dateString) {
      this.gisWaterEvent.planStartTime = dateString
    },
    onChanget (value, dateString) {
      this.gisWaterEvent.planEntTime = dateString
    },
    handleEventOk (e) {
      e.preventDefault()
      this.$refs.gisWaterEvent.validate(valid => {
        if (valid) {
          this.$http.post(this.addOrUpdateUrl, {
            ...this.gisWaterEvent,
            lineId: this.currentDisplayPipelineId
          })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(res.message)
                this.resetEventForm()
                this.addEventVisible = false
                // 刷新关联停水事件
                this.loadLinkedWaterEvent(this.currentDisplayPipelineId)
              }
            })
            .catch(() => {})
        }
      })
    },
    handleEventCancel () {
      this.resetEventForm()
      this.addEventVisible = false
    },
    resetEventForm () {
      this.$refs.gisWaterEvent && this.$refs.gisWaterEvent.resetFields()
      this.gisWaterEvent = {
        lineId: this.currentDisplayPipelineId || '',
        eventName: '',
        startClassNo: '',
        endClassNo: '',
        endValue: '',
        startValue: '',
        describe: '',
        planEntTime: '',
        planStartTime: '',
        waterAdminName: '',
        eventAddress: '',
        fileNames: [],
        adminId: '',
        principalId: '',
        templateId: undefined
      }
      this.fileNamesimg = []
      this.fileNamestex = []
    },
    clicimg (url) {
      this.previewUrl = url
      this.previewVisible = true
    },
    customRequest (data) {
      const formData = new FormData()
      formData.append('file', data.file)
      this.saveFile(formData)
    },
    saveFile (formData) {
      this.axios({
        method: 'post',
        url: this.uploadUrl,
        headers: {},
        params: {},
        data: formData
      }).then(response => {
        if (response.code === 0) {
          const obj = { url: response.data.url, name: response.data.fileName }
          if (this.gisWaterEvent.fileNames.length >= 5) {
            this.$message.error('最多上传5个文件')
            return
          }
          this.gisWaterEvent.fileNames.push(obj)
          const ext = obj.url.substr(obj.url.lastIndexOf('.') + 1).toLowerCase()
          const isImage = ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].includes(ext)
          if (isImage) {
            this.fileNamesimg.push(obj)
          } else {
            this.fileNamestex.push(obj)
          }
        }
      }).catch(err => {
        console.error(err)
      })
    },
    uploadFile (item) {
      const link = document.createElement('a')
      link.download = item.name
      link.style.display = 'none'
      link.href = item.url
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    deleteFile (url) {
      const index = this.gisWaterEvent.fileNames.findIndex(item => item.url === url)
      if (index > -1) {
        this.gisWaterEvent.fileNames.splice(index, 1)
        this.fileNamesimg = this.fileNamesimg.filter(item => item.url !== url)
        this.fileNamestex = this.fileNamestex.filter(item => item.url !== url)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.footer {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.water-event-info {
  margin-top: 12px;
  min-height: 36px;
}

.event-empty {
  font-size: 12px;
  color: #888;
  padding: 8px 4px;
  display: flex;
  align-items: center;
}

.event-card {
  border: 1px solid #ffe58f;
  border-radius: 6px;
  background: #fffbe6;
  padding: 10px 12px;

  .event-card-header {
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    .event-icon {
      color: #faad14;
      font-size: 14px;
      margin-right: 6px;
    }

    .event-label {
      font-weight: 600;
      font-size: 13px;
      color: #333;
      flex: 1;
    }

    .event-status-tag {
      font-size: 11px;
    }
  }

  .event-card-body {
    .event-field {
      font-size: 12px;
      color: #555;
      margin-bottom: 4px;
      display: flex;

      .field-label {
        color: #888;
        white-space: nowrap;
        flex-shrink: 0;
      }

      .field-value {
        color: #333;
        word-break: break-all;
      }
    }
  }

  .event-card-footer {
    margin-top: 10px;
    display: flex;
    align-items: center;
  }
}

.add-event-btn {
  height: 36px;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s ease;
  border: 2px dashed #1890ff;
  background-color: #e6f7ff;
  color: #1890ff;

  &:hover {
    transform: translateY(-2px);
    border-color: #40a9ff;
    background-color: #bae7ff;
    color: #40a9ff;
  }

  &:active {
    transform: translateY(0);
  }

  &[disabled] {
    transform: none;
    background-color: #f5f5f5;
    border-color: #d9d9d9;
    color: rgba(0, 0, 0, 0.25);
  }
}

.event-form {
  .ant-form-item {
    margin-bottom: 16px;
  }
  
  .template-textarea {
    background-color: #f5f5f5;
    color: #666;
    font-family: Consolas, Monaco, monospace;
    cursor: not-allowed;
  }

  .custom-dragger {
    .ant-upload-drag-icon {
      margin-bottom: 8px;
    }
    .ant-upload-text {
      font-size: 14px;
      color: #333;
    }
    .ant-upload-hint {
      font-size: 12px;
      color: #999;
      margin-top: 4px;
    }
  }

  .upload-preview-area {
    margin-top: 16px;
    background: #fafafa;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    padding: 12px;

    .preview-section {
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0;
      }

      .section-title {
        font-size: 13px;
        color: #555;
        margin-bottom: 8px;
        font-weight: 500;
      }

      .image-list {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;

        .image-item {
          position: relative;
          width: 64px;
          height: 64px;
          border-radius: 4px;
          overflow: hidden;
          border: 1px solid #d9d9d9;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            cursor: pointer;
          }

          .delete-mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            opacity: 0;
            transition: opacity 0.3s;
            cursor: pointer;

            &:hover {
              opacity: 1;
            }
          }
        }
      }

      .file-list {
        display: flex;
        flex-direction: column;
        gap: 6px;

        .file-item {
          display: flex;
          align-items: center;
          padding: 4px 8px;
          background: #fff;
          border: 1px solid #e8e8e8;
          border-radius: 4px;
          font-size: 12px;
          transition: all 0.3s;

          &:hover {
            background: #f0f5ff;
            border-color: #adc6ff;
          }

          .file-icon {
            color: #1890ff;
            margin-right: 6px;
          }

          .file-name {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #333;
            cursor: pointer;

            &:hover {
              color: #1890ff;
            }
          }

          .delete-icon {
            color: #ff4d4f;
            cursor: pointer;
            margin-left: 8px;
            font-size: 14px;

            &:hover {
              color: #ff7875;
            }
          }
        }
      }
    }
  }
}

.fileDiv {
  .fileLi {
    list-style: none;
    display: inline-block;
    margin-right: 8px;
    margin-bottom: 8px;
  }
  ul {
    padding: 0;
    margin: 0;
  }
}

.detail-descriptions {
  .ant-descriptions-item-label {
    width: 130px;
    background-color: #fafafa;
    color: #666;
  }
  .ant-descriptions-item-content {
    color: #333;
  }
}

.detail-file-list {
  display: flex;
  flex-direction: column;
  gap: 8px;

  .detail-file-item {
    display: flex;
    align-items: center;
    font-size: 13px;
    
    a {
      color: #1890ff;
      &:hover {
        color: #40a9ff;
        text-decoration: underline;
      }
    }
  }
}

.uploadDiv {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  color: #1890ff;
  &:hover {
    color: #40a9ff;
  }
}

// 筛选按钮样式
.filter-btn {
  height: 36px;
  font-size: 13px;
  font-weight: 500;
  background: linear-gradient(135deg, #1890ff, #096dd9);
  border: none;
  color: #fff;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #40a9ff, #1890ff);
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.5);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  // 选中状态（红底白字）
  &.active {
    background: linear-gradient(135deg, #ff4d4f, #cf1322);
    border: none;
    color: #fff;
    box-shadow: 0 2px 8px rgba(255, 77, 79, 0.4);

    &:hover {
      background: linear-gradient(135deg, #ff7875, #ff4d4f);
      box-shadow: 0 4px 12px rgba(255, 77, 79, 0.6);
    }
  }
}

.action-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
}

.superior-btn {
  background: #fff;
  border: 1px solid #1890ff;
  color: #1890ff;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(24, 144, 255, 0.15);
  transition: all 0.3s ease;

  &:hover {
    background: #e6f7ff;
    border-color: #40a9ff;
    color: #40a9ff;
    box-shadow: 0 4px 8px rgba(24, 144, 255, 0.3);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  // 已选中状态
  &.selected {
    background: linear-gradient(135deg, #52c41a, #389e0d);
    border: none;
    color: #fff;
    box-shadow: 0 2px 4px rgba(82, 196, 26, 0.3);

    &:hover {
      background: linear-gradient(135deg, #73d13d, #52c41a);
      box-shadow: 0 4px 8px rgba(82, 196, 26, 0.5);
      transform: translateY(-2px);
    }
  }

  :deep(.anticon) {
    font-size: 12px;
  }
}

.display-btn {
  background: #fff;
  border: 1px solid #d9d9d9;
  color: #595959;
  font-weight: 500;
  transition: all 0.3s ease;

  &:hover {
    color: #40a9ff;
    border-color: #40a9ff;
    background: #f0f8ff;
    transform: translateY(-2px);
    box-shadow: 0 2px 4px rgba(64, 169, 255, 0.2);
  }

  &:active {
    transform: translateY(0);
  }

  // 展示中状态
  &.displayed {
    background: linear-gradient(135deg, #fa8c16, #d46b08);
    border: none;
    color: #fff;
    box-shadow: 0 2px 4px rgba(250, 140, 22, 0.3);

    &:hover {
      background: linear-gradient(135deg, #ffa940, #fa8c16);
      box-shadow: 0 4px 8px rgba(250, 140, 22, 0.5);
      transform: translateY(-2px);
      color: #fff;
    }
  }

  :deep(.anticon) {
    font-size: 12px;
  }
}

// 表格样式优化
:deep(.ant-table) {
  .ant-table-tbody>tr {
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #f5f5f5;
    }

    // 已选中行的样式
    &.selected-row {
      background-color: #e6f7ff;
      border-left: 3px solid #1890ff;

      &:hover {
        background-color: #bae7ff;
      }
    }
  }

  .ant-table-tbody>tr>td {
    padding: 12px 8px;
  }

  // 表格头部居中
  .ant-table-thead>tr>th {
    text-align: center;
    font-weight: 600;
    background: #fafafa;
  }

  // 表格滚动容器 - 纵向滚动条样式
  .ant-table-body {

    // 自定义纵向滚动条样式
    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 3px;

      &:hover {
        background-color: rgba(0, 0, 0, 0.3);
      }
    }

    &::-webkit-scrollbar-track {
      background-color: rgba(0, 0, 0, 0.05);
      border-radius: 3px;
    }
  }

  // 加载状态样式优化
  .ant-spin {
    .ant-spin-dot {
      font-size: 24px;
    }

    .ant-spin-text {
      color: #1890ff;
      font-size: 14px;
      margin-top: 8px;
    }
  }
}
</style>